import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import FaqCom from "../Faq/FaqComponent";
import {BASE_URL} from '../../config.json'
import CustomLoader from "../Reusable/CustomLoader";
const Accordion = () =>{
    const [posts,setPosts] = useState([])
    const [setActive, setActiveState]= useState("")
    const [loading,setLoading]= useState(false)


    const content = useRef(null);
    function toggleAccordion() {


    }

    useEffect(()=>{
        setLoading(true)
        axios.get(`${BASE_URL}/faq`)
            .then(res =>{
                console.log(res)


                setPosts(res.data.data)
                setLoading(false)
            })
            .catch(err=>{
                console.log(err)
            })
    },[])

    return(
        <>



                {
                    loading?    <CustomLoader
                            type={'spinner-cub'}
                            title={''}
                            color={'#B4C227'}
                            size={100}
                        />:
                    posts.map((post,i) => (


                    <FaqCom post={post} index={i}  />

                    ))
                }


        </>
    );
};
export default Accordion;
